import { events } from "../../../exports/event-q-bus";
import { executeCallbackAsync } from "./callback";

import type { DeviceEvents } from "./events";

export enum OrientationType {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
  UNKNOWN = "unknown",
}

/**
 *
 */
export type OrientationTypes = keyof typeof OrientationType;

/**
 *
 *
 */
export type OrientationChangedCallback = (activeOrientation: OrientationTypes) => unknown;

/**
 *
 */
export class Orientation {
  private callbacks: OrientationChangedCallback[] = [];

  private orientation: {
    portrait: MediaQueryList;
    landscape: MediaQueryList;
  } = import.meta.env.SSR
    ? {
        get portrait(): MediaQueryList {
          throw new Error("Orientation detection is not supported in SSR environment");
        },
        get landscape(): MediaQueryList {
          throw new Error("Orientation detection is not supported in SSR environment");
        },
      }
    : {
        portrait: window.matchMedia(`(orientation: ${OrientationType.PORTRAIT})`),
        landscape: window.matchMedia(`(orientation: ${OrientationType.LANDSCAPE})`),
      };

  /**
 *
 */
  constructor() {
    if (!import.meta.env.SSR) {
      this.initializeOrientationListeners();
    }
  }

  /**
 *
 */
  getCurrentOrientation(): OrientationType {
    if (this.isPortrait()) {
      return OrientationType.PORTRAIT;
    }

    if (this.isLandscape()) {
      return OrientationType.LANDSCAPE;
    }

    return OrientationType.UNKNOWN;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  onOrientationChanged(callback: OrientationChangedCallback): this {
    this.callbacks.push(callback);
    return this;
  }

  /*                                                       */
  registerChangeListener = this.onOrientationChanged;

  private trigger(mql: MediaQueryListEvent): void {
    /*                                                       */
    /*                                                 */
    /*                                                    */
    /*                                                                              */

    if (mql.matches) {
      /*                                                         */
      const currentOrientation = this.getCurrentOrientation() as unknown as OrientationTypes;

      this.callbacks.forEach((cb) => {
        executeCallbackAsync(cb, currentOrientation);
      });

      events<DeviceEvents>().emit("assets.device.orientation.changed", currentOrientation);
    }
  }

  /*                                  */
  private initializeOrientationListeners(): this {
    /*                                               */
    /*                                                                                  */
    /*                                                       */
    this.orientation.portrait.addListener((e) => this.trigger(e));

    this.orientation.landscape.addListener((e) => this.trigger(e));

    return this;
  }

  /**
 *
 */
  isPortrait(): boolean {
    return this.orientation.portrait.matches;
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  isLandscape(): boolean {
    return this.orientation.landscape.matches;
  }
}

/**
 *
 *
 *
 *
 */
export function detectOrientation(): Orientation {
  return new Orientation();
}
